export { default } from './HeaderDark';
